/**
 * @file Renders the page footer with the platform logo and version.
 */
import { Typography, Space } from "antd";

import { getConfig } from "@components/Config";
import { isMobile, W1, W5 } from "@components/Constants";

import PoweredByLogo from "./PoweredByLogo";

const PLATFORM_WEBSITE = getConfig<string>("PLATFORM_WEBSITE");
const PLATFORM_VERSION = getConfig<string>("PLATFORM_VERSION");

type Props = {
  marginTop?: number;
  shouldRenderOnMobile?: boolean;
};

/**
 * Renders the platform's powered-by logo and copyright line, hidden
 * on mobile unless asked to render there.
 */
const PlatformFooter = ({
  marginTop = W5 * 2,
  shouldRenderOnMobile = false,
}: Props): JSX.Element | null => {
  const shouldRender = !isMobile || shouldRenderOnMobile;

  if (!shouldRender) {
    return null;
  }

  const yearDate = new Date().getFullYear();

  const style = {
    marginBottom: W1,
    marginTop,
  };

  return (
    <footer style={style}>
      <center>
        <Space direction="vertical" size={0}>
          <PoweredByLogo
            width={260}
            style={{ opacity: 0.25 }}
          />

          <Typography.Text strong style={{ color: "rgb(191, 191, 191)", fontWeight: 500 }}>
            {`© ${yearDate} ${PLATFORM_WEBSITE} / v${PLATFORM_VERSION}`}
          </Typography.Text>
        </Space>
      </center>
    </footer>
  );
};

export default PlatformFooter;
